import moment from "moment";
import { GetCompletedApplications } from "types/gql-types";

export const getCurrentYear = (): number => new Date().getFullYear();
export const getLastYear = (): number => getCurrentYear() - 1;
export const getCurrentMonth = (): string => moment().format("MMM YYYY");
export const getLastMonth = (): string => moment().subtract(1, "months").format("MMM YYYY");

const getYearCounts =
  (data: GetCompletedApplications | undefined, year: number): number => {
    if (!data) return 0;
    return data.completedApplicationsByMonth
      .filter((item) => new Date(item.month).getFullYear() === year)
      .reduce((acc, item) => acc + item.count, 0);
  };

export const getLastYearCounts = (data: GetCompletedApplications | undefined): number => {
  const lastYear = getLastYear();
  return getYearCounts(data, lastYear);
};

export const getThisYearCounts = (data: GetCompletedApplications | undefined): number => {
  const thisYear = getCurrentYear();
  return getYearCounts(data, thisYear);
};

const getCountForSpecificMonth = (
  data: GetCompletedApplications | undefined,
  year: number,
  month: number, // month as 1-12 for January-December
): number => {
  if (!data) return 0;

  // Format month and year using Moment.js
  const monthKey = moment({ year, month: month - 1 }).format("YYYY-MM");

  const monthData = data.completedApplicationsByMonth.find(
    (item) => item.month === monthKey,
  );

  return monthData ? monthData.count : 0;
};

export const getCurrentMonthData = (data: GetCompletedApplications | undefined): number =>
  getCountForSpecificMonth(
    data,
    moment().year(),
    moment().month() + 1, // month() returns 0-11, so add 1 for 1-12 format
  );

export const getLastMonthData = (data: GetCompletedApplications | undefined): number =>
  getCountForSpecificMonth(
    data,
    moment().subtract(1, "months").year(),
    moment().subtract(1, "months").month() + 1,
  );
